import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from '../containers/Auth/auth.reducer';
import appState from './appState';
import questionReducer from './questionReducer';
import sessionReducer from './sessionReducer';
import user from './userReducer';
import school from './schoolReducer';
import interaction from './interactionReducer';
import curiosity from './curiosityReducer';
import courseReducer from './courseReducer';
import missionReducer from './missionReducer';
import loadingReducer from './loadingReducer';
import dashboardReducer from './dashboardReducer';
import timeReducer from './timeReducer';
import screenReducer from './screenReducer';
import simpleModalReducer from './simpleModalReducer';
import restartModalConfirmationReducer from './restartModalConfirmationReducer';

export default combineReducers({
    auth,
    appState,
    questionReducer,
    sessionReducer,
    router: routerReducer,
    loadingReducer,
    user,
    school,
    courseReducer,
    dashboardReducer,
    screenReducer,
    missionReducer,
    interaction,
    curiosity,
    timeReducer,
    simpleModalReducer,
    restartModalConfirmationReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js